<template>
	<div
		class="flow-new-placeholder text-align-center"
		:compact="compact"
		:direction="direction"
		:tabindex="tabindex"
		@click="handleClick($event)"
	>
		<div v-if="!onlyIcon" class="env-plus-container" @click="handlePlusClick($event)">
			<Icon name="i-plus" state="dark" :effects="false" size="x-small" />
		</div>
		<Icon v-if="onlyIcon" name="i-plus" state="dark" :effects="false" size="x-small" />
		<slot v-if="!compact" />
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";

export default defineComponent({
	name: "NewPlaceholder",
	components: {
		Icon
	},
	props: {
		/**
		 * true | false
		 */
		compact: {
			type: Boolean,
			default: false
		},
		direction: {
			type: String,
			default: "column",
			validator(value) {
				return ["column", "row", "row-reverse", "column-reverse"].includes(value);
			}
		},
		/**
		 * tabindex number
		 *  */
		tabindex: {
			type: Number,
			default: -1
		},
		/**
		 * true | false
		 */
		onlyIcon: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClick(e) {
			e.stopPropagation();
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);
		},
		handlePlusClick(e) {
			//	e.stopPropagation();
			/**
			 * Click event
			 *
			 * @event plusClick
			 */
			this.$emit("plusClick", e);
		}
	}
});
</script>
<style lang="scss">
@mixin placeholder-mixin($border, $primary, $element) {
	div.flow-new-placeholder {
		border: 1px dashed $border;
		> div.env-plus-container {
			background-color: $primary;
		}
		&[compact] {
			&::before {
				background-color: transparent;
			}
		}
		&::before {
			background-color: $element;
		}

		&:focus:not([compact]) {
			box-shadow: inset 0 0 0 2px $primary;
		}
	}
}

@include placeholder-mixin(
	var(--dashboard-border),
	var(--dashboard-primary),
	var(--dashboard-element)
);

.sideout-container {
	@include placeholder-mixin(
		var(--slideout-border),
		var(--slideout-primary),
		var(--slideout-element)
	);
}
div.flow-new-placeholder {
	display: flex;
	cursor: pointer;
	outline: none;

	width: auto;
	height: auto;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	position: relative;
	background-color: transparent;
	z-index: 2;
	padding: 8px;

	> * {
		z-index: 2;
	}

	&[direction="column"] {
		flex-direction: column;
		> div.env-plus-container {
			margin: 0px 0px 8px 0px;
		}
	}
	&[direction="row"] {
		flex-direction: row;

		> div.env-plus-container {
			margin: 0px 12px 0px 0px;
		}
	}
	&[direction="column-reverse"] {
		flex-direction: column-reverse;
		> div.env-plus-container {
			margin: 8px 0px 0px 0px;
		}
	}
	&[direction="row-reverse"] {
		flex-direction: row-reverse;

		> div.env-plus-container {
			margin: 0px 0px 0px 12px;
		}
	}
	> div.env-plus-container {
		display: inline-flex;
		height: 24px;
		width: 24px;
		border-radius: 12px;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}
	&[compact] {
		max-width: 24px;
		height: 24px;
		width: 24px;
		padding: 0px;
		border: none;

		> div.env-plus-container {
			margin: 0px 0px 0px 0px;
		}
	}
	&::before {
		position: absolute;
		content: "";
		width: 100%;
		height: 100%;
		opacity: 0.2;
		z-index: 1;
		border-radius: 4px;
	}

	&:focus:not([compact]) {
		outline: none;
	}
}
</style>
